import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram,faYoutube } from '@fortawesome/free-brands-svg-icons';
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <h2>Contact Us</h2>
        <div className="contact-info">
          <div className="contact-item">
            <FontAwesomeIcon icon={faPhone} className="contact-icon" />
            <span>+91-8789853321</span>
          </div>
          <div className="contact-item">
            <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
            <span>everbloominteriors@gmail.com</span>
          </div>
        </div>
        <h2>Follow Us</h2>
        <div className="social-icons">
          <a href="https://www.facebook.com/profile.php?id=61573890830226" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faFacebookF} className="icon" />
          </a>
          <a href="https://www.instagram.com/interiors_everbloom/?hl=en" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faInstagram} className="icon" />
          </a>
          <a href="https://www.youtube.com/@interiors_everbloom" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faYoutube} className="icon" />
          </a>
        </div>
        <p>&copy; 2025 Ever Bloom. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
